// refactor sass to stylejs (no theme usage)
import { css } from '@emotion/react';

export const globalStyles = css`
  :root {
    --toastify-color-light: #fff !important;
    --toastify-color-dark: #121212 !important;
    --toastify-color-info: #e1e8ff !important;
    --toastify-color-success: #deffee !important;
    --toastify-color-warning: #ffede3 !important;
    --toastify-color-error: #ffecef !important;
    --toastify-toast-background: #fff !important;
    --toastify-font-family: inherit !important;
    --toastify-text-color-light: #424242 !important;
    --toastify-toast-width: 400px !important;
    --toastify-text-color-info: #424242 !important;
    --toastify-text-color-success: #424242 !important;
    --toastify-text-color-warning: #424242 !important;
    --toastify-text-color-error: #424242 !important;
    --toastify-spinner-color: #616161 !important;
    --toastify-spinner-color-empty-area: #e0e0e0 !important;
  }

  .Toastify__close-button {
    color: #424242 !important;
  }

  .Toastify__progress-bar--info {
    background-color: #4c6fff !important;
  }

  .Toastify__progress-bar--warning {
    background-color: #f7936f !important;
  }

  .Toastify__progress-bar--error {
    background-color: #f16063 !important;
  }

  .Toastify__progress-bar--success {
    background-color: #66cb9f !important;
  }

  .Toastify__progress-bar--rtl {
    transform-origin: left !important;
  }

  .custom-toast .actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    margin-bottom: 10px;
  }

  .custom-toast .actions .MuiButton-label {
    color: #4c6fff;
  }

  .stream-header-menu {
    z-index: 1200;
  }

  .stream-header-menu .MuiMenu-paper {
    width: 200px;
    border-radius: 8px;
    border: 1px solid #e4e9ec;
    background: #fff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
  }

  .stream-manager-drawer {
    z-index: 1200;
  }

  .stream-manager-drawer * {
    box-sizing: border-box;
  }

  .stream-manager-drawer .MuiPaper-root {
    padding: 0;
    border-radius: 0;
  }

  .show-summery {
    overflow: hidden;
    height: 46px;
  }

  .show-summery::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 6px;
    transform: translateX(-50%);
    opacity: 0;
    animation: ripple-animation 1.2s ease-out 0s 5;
  }

  .show-summery:hover {
    background: linear-gradient(
      270.7deg,
      rgb(22, 137, 142) 5.57%,
      rgb(22, 137, 142) 93.82%
    ) !important;
  }

  .show-daily-summery {
    background: linear-gradient(
      98deg,
      #d170f1 -12.36%,
      #199da3 50.07%,
      #734983 112.49%
    );
    transition: all 0.2s ease;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 11px 24px;
    line-height: 20px;
    font-size: 13px;
    font-weight: 700;
    font-family: IranYekanNum !important;
    color: #ffffff;
    border-radius: 8px !important;
    cursor: pointer;
    width: stretch;
  }

  .show-daily-summery::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 8px;
    transform: translateX(-50%);
    opacity: 0;
    animation: ripple-animation 1.2s ease-out 0s 5;
  }

  .show-daily-summery:hover {
    filter: brightness(0.92);
  }

  .show-daily-summery.disabled {
    background: #e4e9ec;
    color: #aaaaaa;
    opacity: 1;
  }

  @keyframes ripple-animation {
    0% {
      width: 0;
      opacity: 0.7;
    }
    100% {
      width: 100%;
      opacity: 0.1;
    }
  }
`;
